// extracted by mini-css-extract-plugin
module.exports = {"book-container":"book_book-container__c0qIL"};